import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import useDetailHandler from '../../hooks/useDetailHandler';
import HeaderProduct from './HeaderProduct';
import AuctionHeaderNumberOfLots from './energy/AuctionHeaderNumberOfLots';
import AuctionHeaderEnergyPerLot from './energy/AuctionHeaderEnergyPerLot';
import AuctionHeaderProgress from './AuctionHeaderProgress';
import AuctionHeaderPhase from './AuctionHeaderPhase';
import AuctionDetail from './AuctionDetail';
import { auctionPropertiesType, auctionType } from '../../types';
import './_styles_/AuctionRow.css';
import { getAllUIPhases } from '../../utils/AuctionPhase';
import { onActionKey } from '../../utils';
import AuctionHeaderQuantity from './security/AuctionHeaderQuantity';
import FlagIcon from '../FlagIcon';
import { getScope, getAllScopes } from '../../utils/Scopes';
import DateTime, {LONG_DATE} from "../DateTime";

export const getValueMapping = (t) => ({
    phase: getAllUIPhases().map((phase) => ({ from: phase.serverPhase, to: phase.translate(t) })),
    scope: getAllScopes().map((scope) => ({ from: scope.serverType, to: scope.translate(t) })),
});

AuctionRow.propTypes = {
    auction: auctionType.isRequired,
    auctionProps: auctionPropertiesType.isRequired,
    activeProductType: PropTypes.string,
};

function AuctionRow(props) {
    const {
        auction,
        auctionProps,
        activeProductType = null,
    } = props;
    const { t } = useTranslation();
    const { isDetailVisible, toggleDetail } = useDetailHandler(auction.id);
    return (
        <>
            <div className="rich-list-row auction-header" onClick={toggleDetail} onKeyUp={onActionKey(toggleDetail)} role="button" tabIndex={0}>
                <div className="auction-header--main">
                    <div className="auction-header--arrow-mobile">
                        <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                    </div>
                    {auction.zone.flagCode && (
                        <>
                            <FlagIcon code={auction.zone.flagCode} size="2x" className="auction-header--flag-icon flag-icon--shadowed flag-icon--32" squared />
                            &nbsp;
                        </>
                    )}
                </div>
                <div className="auction-header--id">
                    {auction.id}
                </div>
                <div className="auction-header--name">
                    {auction.name}
                </div>
                <HeaderProduct product={auction.product} activeProductType={activeProductType} />
                {activeProductType === 'ENERGY' && (
                    <>
                        <AuctionHeaderNumberOfLots numberOfLots={auction.quantity} />
                        <AuctionHeaderEnergyPerLot energyPerLot={auction.energyPerLot} unit={auction.product.quantityUnit} />
                    </>
                )}
                {activeProductType === 'SECURITY' && (
                    <>
                        <div className="auction-header--scope">{auction.scope && getScope(auction.scope).translate(t)}</div>
                        <AuctionHeaderQuantity quantity={auction.quantity} />
                    </>
                )}
                <div className="auction-header--date">
                    <DateTime value={auction.openingTime} format={LONG_DATE} />
                </div>
                <AuctionHeaderProgress auction={auction} />
                <AuctionHeaderPhase phase={auction.phase} />
                <div className="auction-header--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && (
                <AuctionDetail
                    auctionId={auction.id}
                    auctionProps={auctionProps}
                />
            )}
        </>
    );
}

export default AuctionRow;
